import Purchase from "../views/inventory/Purchase.vue";
import PurchaseMark from "../views/inventory/PurchaseMark.vue";
import Transfer from "../views/inventory/Transfer.vue";
import Supplier from "../views/inventory/Supplier.vue";
import Stock from "../views/inventory/Stock.vue";
import Counts from "../views/inventory/Counts.vue";
import Productions from "../views/inventory/Productions.vue";
import SupplierCreate from "../views/inventory/SupplierCreate.vue";
import PurchaseCreate from "../views/inventory/PurchaseCreate.vue";
import PurchaseMarkCreate from "../views/inventory/PurchaseMarkCreate.vue";
import PurchaseView from "../views/inventory/PurchaseView.vue";
import TransferCreate from "../views/inventory/TransferCreate.vue";
import TransferView from "../views/inventory/TransferView.vue";
import StockCreate from "../views/inventory/StockCreate.vue";
import CountsCreate from "../views/inventory/CountsCreate.vue";
import ProductionsCreate from "../views/inventory/ProductionsCreate.vue";
import InventoryHistory from "../views/inventory/InventoryHistory.vue";
import InventoryValuation from "../views/inventory/InventoryValuation.vue";
import SupplierTransaction from "../views/inventory/SupplierTransaction.vue";
import SupplierTransactionDetail from "../views/inventory/SupplierTransactionDetail.vue";
import Fees from "../views/inventory/Fees.vue";
import FeesCreate from "../views/inventory/FeesCreate.vue";
import SupplierValuation from "../views/inventory/SupplierValuation.vue";
import InventorySupplierValuation from "../views/inventory/InventorySupplierValuation.vue";
import PartitionValuation from "../views/inventory/PartitionValuation";
import PartitionItem from "../views/inventory/PartitionItem.vue";
import PartitionValuationBySupplier from "../views/inventory/PartitionValuationBySupplier";
// purchase pricing
import PurchasePricing from "../views/inventory/PurchasePricing.vue";
import OnlineKassa from "@/views/inventory/OnlineKassa";
import SalesCreate from "@/views/inventory/SalesCreate";
import PurchaseEmployee from "../views/inventory/PurchaseEmployee.vue";
// import PurchaseEmployeeCreate from '../views/inventory/PurchaseEmployeeCreate.vue'
import PurchaseEmployeeView from "../views/inventory/PurchaseEmployeeView.vue";
import InventoryHistoryReport from "../views/inventory/InventoryHistoryReport.vue";
const inventory = [
  {
    path: "/inventory/receive",
    name: "inventory_receive",
    component: () => import("../views/inventory/Receive.vue"),
  },
  {
    path: "/inventory/purchase",
    name: "inventory_purchase",
    component: Purchase,
  },
  {
    path: "/inventory/purchase_mark",
    name: "inventory_purchase_mark",
    component: PurchaseMark,
  },
  { path: "/inventory/sale", name: "sale", component: OnlineKassa },
  { path: "/inventory/sales", name: "sales_create", component: SalesCreate },
  {
    path: "/inventory/pricing/:target",
    name: "pricing_purchase",
    component: PurchasePricing,
  },
  {
    path: "/inventory/purchase/view",
    name: "inventory_puchase_view",
    component: PurchaseView,
  },
  {
    path: "/inventory/purchase/:target",
    name: "inventory_purchase_create",
    component: PurchaseCreate,
  },
  {
    path: "/inventory/purchase_mark/view",
    name: "inventory_purchase_mark_view",
    component: PurchaseView,
  },
  {
    path: "/inventory/purchase_mark/:target",
    name: "inventory_purchase_mark_create",
    component: PurchaseMarkCreate,
  },
  {
    path: "/inventory/transfer",
    name: "inventory_transfer",
    component: Transfer,
  },
  {
    path: "/inventory/transfer/view",
    name: "inventory_transfer_view",
    component: TransferView,
  },
  {
    path: "/inventory/transfer/:target",
    name: "inventory_transfer_create",
    component: TransferCreate,
    props: (route) => ({
      itemsX: route.query.itemsX,
      service_id: route.query.service_id,
    }),
  },
  {
    path: "/inventory/suppliers",
    name: "inventory_suplliers",
    component: Supplier,
  },
  {
    path: "/inventory/suppliers/:target",
    name: "inventory_suppliers_create",
    component: SupplierCreate,
  },
  { path: "/inventory/stock", name: "inventory_stock", component: Stock },
  {
    path: "/inventory/stock/view",
    name: "inventory_stock_view",
    component: () => import("../views/inventory/StockView.vue"),
  },
  {
    path: "/inventory/stock/:target",
    name: "inventory_stock_create",
    component: StockCreate,
  },
  { path: "/inventory/counts", name: "inventory_counts", component: Counts },
  {
    path: "/inventory/counts/complete",
    name: "inventory_counts_complete",
    component: () => import("../views/inventory/CountsComplete.vue"),
  },
  {
    path: "/inventory/counts/view",
    name: "inventory_counts_view",
    component: () => import("../views/inventory/CountsView.vue"),
  },
  {
    path: "/inventory/counts/:target",
    name: "inventory_counts_create",
    component: CountsCreate,
  },
  {
    path: "/inventory/productions",
    name: "inventory_productions",
    component: Productions,
  },
  {
    path: "/inventory/productions/view",
    name: "inventory_productions_view",
    component: () => import("../views/inventory/ProductionsView.vue"),
  },
  {
    path: "/inventory/productions/:target",
    name: "inventory_productions_create",
    component: ProductionsCreate,
  },
  {
    path: "/inventory/print",
    name: "inventory_print",
    component: () => import("../views/inventory/Print.vue"),
  },
  {
    path: "/inventory/history",
    name: "inventory_history",
    component: InventoryHistory,
  },
  { path: "/partition/item", name: "partition_item", component: PartitionItem },
  {
    path: "/partition/valuation",
    name: "partition_valuation",
    component: PartitionValuation,
  },
  {
    path: "/inventory/valuation",
    name: "inventory_valuation",
    component: InventoryValuation,
  },
  {
    path: "/partition/valuation/data",
    name: "partition_valuation_data",
    component: PartitionValuationBySupplier,
  },
  {
    path: "/inventory/supplier/transactions",
    name: "supplier_transaction",
    component: SupplierTransaction,
  },
  {
    path: "/inventory/supplier/transactions/update",
    name: "supplier_transaction_detail",
    component: SupplierTransactionDetail,
  },
  { path: "/inventory/fees", name: "fees", component: Fees },
  {
    path: "/inventory/fees/create",
    name: "fees_create",
    component: FeesCreate,
  },
  {
    path: "/inventory/supplier/valuation",
    name: "supplier_valuation",
    component: SupplierValuation,
  },
  {
    path: "/inventory/supplier/valuation/data",
    name: "supplier_valuation_data",
    component: InventorySupplierValuation,
  },
  {
    path: "/purchase/employee",
    name: "employee_purchase",
    component: PurchaseEmployee,
  },
  // { path: '/purchase/employee/:target', name: 'employee_purchase_create', component: PurchaseEmployeeCreate },
  {
    path: "/purchase/employee/view",
    name: "employee_purchase_view",
    component: PurchaseEmployeeView,
  },
  {
    path: "/inventory/report",
    name: "inventory_history_report",
    component: InventoryHistoryReport,
  },
];

export default {
  inventory,
};

// function lazyLoad(view) {
//   return () => import(`@/views/inventory/${view}.vue`)
// }

// const inventory = [
//   {
//     path: '/inventory/receive', name: 'inventory_receive', component: () => import(
//       '../views/inventory/Receive.vue'
//     )
//   },
//   { path: '/inventory/purchase', name: 'inventory_purchase', component: lazyLoad('Purchase') },
//   { path: '/inventory/purchase_mark', name: 'inventory_purchase_mark', component: lazyLoad('PurchaseMark') },
//   {
//     path: '/inventory/sale', name: 'sale', component: () => import(
//       '@/views/inventory/OnlineKassa'
//     )
//   },
//   {
//     path: '/inventory/sales', name: 'sales_create', component: () => import(
//       '@/views/inventory/SalesCreate'
//     )
//   },
//   { path: '/inventory/pricing/:target', name: 'pricing_purchase', component: lazyLoad('PurchasePricing') },
//   { path: '/inventory/purchase/view', name: 'inventory_puchase_view', component: lazyLoad('PurchaseView') },
//   { path: '/inventory/purchase/:target', name: 'inventory_purchase_create', component: lazyLoad('PurchaseCreate') },
//   { path: '/inventory/purchase_mark/view', name: 'inventory_purchase_mark_view', component: lazyLoad('PurchaseView') },
//   { path: '/inventory/purchase_mark/:target', name: 'inventory_purchase_mark_create', component: lazyLoad('PurchaseMarkCreate') },
//   { path: '/inventory/transfer', name: 'inventory_transfer', component: lazyLoad('Transfer') },
//   { path: '/inventory/transfer/view', name: 'inventory_transfer_view', component: lazyLoad('TransferView') },
//   { path: '/inventory/transfer/:target', name: 'inventory_transfer_create', component: lazyLoad('TransferCreate') },
//   { path: '/inventory/suppliers', name: 'inventory_suplliers', component: lazyLoad('Supplier') },
//   { path: '/inventory/suppliers/:target', name: 'inventory_suppliers_create', component: lazyLoad('SupplierCreate') },
//   { path: '/inventory/stock', name: 'inventory_stock', component: lazyLoad('Stock') },
//   {
//     path: '/inventory/stock/view', name: 'inventory_stock_view', component: () => import(
//       '../views/inventory/StockView.vue'
//     )
//   },
//   { path: '/inventory/stock/:target', name: 'inventory_stock_create', component: lazyLoad('StockCreate') },
//   { path: '/inventory/counts', name: 'inventory_counts', component: lazyLoad('Counts') },
//   {
//     path: '/inventory/counts/complete', name: 'inventory_counts_complete', component: () => import(
//       '../views/inventory/CountsComplete.vue'
//     )
//   },
//   {
//     path: '/inventory/counts/view', name: 'inventory_counts_view', component: () => import(
//       '../views/inventory/CountsView.vue'
//     )
//   },
//   { path: '/inventory/counts/:target', name: 'inventory_counts_create', component: lazyLoad('CountsCreate') },
//   { path: '/inventory/productions', name: 'inventory_productions', component: lazyLoad('Productions') },
//   {
//     path: '/inventory/productions/view', name: 'inventory_productions_view', component: () => import(
//       '../views/inventory/ProductionsView.vue'
//     )
//   },
//   { path: '/inventory/productions/:target', name: 'inventory_productions_create', component: lazyLoad('ProductionsCreate') },
//   {
//     path: '/inventory/print', name: 'inventory_print', component: () => import(
//       '../views/inventory/Print.vue'
//     )
//   },
//   { path: '/inventory/history', name: 'inventory_history', component: lazyLoad('InventoryHistory') },
//   { path: '/partition/item', name: 'partition_item', component: lazyLoad('PartitionItem') },
//   { path: '/partition/valuation', name: 'partition_valuation', component: lazyLoad('PartitionValuation') },
//   { path: '/inventory/valuation', name: 'inventory_valuation', component: lazyLoad('InventoryValuation') },
//   {
//     path: '/partition/valuation/data', name: 'partition_valuation_data', component: () => import(
//       '../views/inventory/PartitionValuationBySupplier'
//     )
//   },
//   { path: '/inventory/supplier/transactions', name: 'supplier_transaction', component: lazyLoad('SupplierTransaction') },
//   { path: '/inventory/supplier/transactions/update', name: 'supplier_transaction_detail', component: lazyLoad('SupplierTransactionDetail') },
//   { path: '/inventory/fees', name: 'fees', component: lazyLoad('Fees') },
//   { path: '/inventory/fees/create', name: 'fees_create', component: lazyLoad('FeesCreate') },
//   { path: '/inventory/supplier/valuation', name: 'supplier_valuation', component: lazyLoad('SupplierValuation') },
//   { path: '/inventory/supplier/valuation/data', name: 'supplier_valuation_data', component: lazyLoad('InventorySupplierValuation') },
//   { path: '/purchase/employee', name: 'employee_purchase', component: lazyLoad('PurchaseEmployee') },
//   // { path: '/purchase/employee/:target', name: 'employee_purchase_create', component: PurchaseEmployeeCreate },
//   { path: '/purchase/employee/view', name: 'employee_purchase_view', component: lazyLoad('PurchaseEmployeeView') },
//   { path: '/inventory/report', name: 'inventory_history_report', component: lazyLoad('InventoryHistoryReport') },
// ]
